import React from 'react';

import { useGroupSubscription } from '../../../hooks';
import { Spinner } from '../../BaseUI';
import GiftForm from './GiftForm';
import SubscriptionOverview from './SubscriptionOverview';
import styles from './styles.module.css';

const Layout = () => {
  const { data: recipients, isLoading } = useGroupSubscription();

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <div className={styles.giftSectionHeader}>
            <div className={styles.settingsSectionHeadingText}>Gift The Information</div>
            <div className={styles.settingsSectionHeadingLine}></div>
          </div>
          <div className={styles.giftSubHeader} id="GiftSubHeader">
            You can give others access to The Information. Share as a gift or with your team—add
            additional subscribers for $199 a year per person.
          </div>
          <div className={styles.giftForms}>
            <GiftForm />
          </div>
          <div className={styles.giftSectionHeader}>
            <div className={styles.settingsSectionHeadingText}>Subscriptions</div>
            <div className={styles.settingsSectionHeadingLine}></div>
          </div>
          <div className={styles.giftSubHeader} id="GiftSubHeader">
            You are currently supporting the following subscriptions for others to The Information
          </div>
          <SubscriptionOverview recipients={recipients} />
        </>
      )}
    </>
  );
};

export default Layout;
